import React from "react";
import PropTypes from "prop-types";
import { Store } from "public-components/StoreProvider";
import DesktopHeader from "./DesktopHeader.js";
import MobileHeader from "./MobileHeader.js";
import baseUrl from "constants/baseUrl.js";
import axios from "axios";

import useSiteHeaderEN from "hooks/use-site-header-en.js";
import useSiteHeaderES from "hooks/use-site-header-es.js";
import useSiteHeaderPT from "hooks/use-site-header-pt.js";
import useSiteHeaderRU from "hooks/use-site-header-ru.js";
import useSiteHeaderFR from "hooks/use-site-header-fr.js";
import useSiteHeaderDE from "hooks/use-site-header-de.js";
import useSiteHeaderCN from "hooks/use-site-header-cn.js";
import useSiteHeaderTW from "hooks/use-site-header-tw.js";
import useSiteHeaderJP from "hooks/use-site-header-jp.js";

const menuDataEnum = {
  1: useSiteHeaderEN,
  2: useSiteHeaderES,
  3: useSiteHeaderPT,
  4: useSiteHeaderRU,
  5: useSiteHeaderFR,
  6: useSiteHeaderDE,
  7: useSiteHeaderCN,
  8: useSiteHeaderTW,
  9: useSiteHeaderJP
};

let FTCommon, FTGetLoginState, FTUserMessage, FTLogout, FTInitEnv, FTIsVIP;
if (typeof window !== `undefined`) {
  const common = require("fotor-common");
  FTCommon = common.FTCommon;
  FTGetLoginState = common.FTGetLoginState;
  FTUserMessage = common.FTUserMessage;
  FTLogout = common.FTLogout;
  FTInitEnv = common.FTInitEnv;
  FTIsVIP = common.FTIsVIP;
}

const Header = (props) => {
  const { state, dispatch } = React.useContext(Store);
  const [showAuthModal, setShowAuthModal] = React.useState(null);
  const headerData = menuDataEnum[props.siteId]();

  const showAuthModalFunc = () => {
    if (showAuthModal === null) {
      setShowAuthModal("loginCOM");
    } else {
      setShowAuthModal(null);
    }
  };

  const checkIsVip = React.useCallback(() => {
    axios.get(`${baseUrl}pay/service/en/payment/check/isvip`).then(function ({ data }) {
      dispatch({
        type: "UPDATE_IS_VIP",
        payload: data.status && data.data.vipStatus ? true : false
      });
    });
  }, [dispatch]);

  const getMessageData = React.useCallback(() => {
    FTUserMessage().then((data) => {
      if (data.status) {
        dispatch({ type: "UPDATE_MESSAGE_DATA", payload: data.data });
      } else {
        dispatch({ type: "LOG_OUT" });
      }
    });
  }, [dispatch]);

  const loginFunc = (res) => {
    if (res.code === 0 || res.code === 2) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      checkIsVip();
      getMessageData();
    }
    if (res.code === 1) {
      dispatch({ type: "LOG_IN", payload: res.userInfo.data });
      getMessageData();
    }
    if (res.code !== 1) {
      setShowAuthModal(null);
    }
  };

  const logoutFunc = () => {
    FTLogout().then((res) => {
      if (res.status) {
        dispatch({ type: "LOG_OUT" });
        setShowAuthModal(null);
      }
    });
  };

  React.useEffect(() => {
    FTInitEnv && FTInitEnv(baseUrl);
    FTGetLoginState().then((res) => {
      if (res.status) {
        dispatch({ type: "LOG_IN", payload: res.data });
        checkIsVip();
        getMessageData();
      } else {
        dispatch({ type: "LOG_OUT" });
        setShowAuthModal(null);
      }
    });
    const handleWindowResize = () => {
      dispatch({ type: "UPDATE_SCREEN_SIZE", payload: document.body.clientWidth > 964 });
    };
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [checkIsVip, dispatch, getMessageData]);

  if (state.isLargeScreen === undefined || state.isLargeScreen || props.forceDesktop) {
    return (
      <>
        <DesktopHeader
          siteId={props.siteId}
          showAuthModalFunc={showAuthModalFunc}
          logoutFunc={logoutFunc}
          showHeaderList={props.showHeaderList}
          maxWidth={props.maxWidth}
          signInButtonModifierClassName={props.signInButtonModifierClassName}
          navigation={props.navigation}
          isHomepage={props.isHomepage}
          headerData={headerData}
        />
        {typeof window !== `undefined` && (
          <FTCommon loginState={loginFunc} modelType={showAuthModal} />
        )}
      </>
    );
  }

  return (
    <>
      <MobileHeader
        siteId={props.siteId}
        showAuthModalFunc={showAuthModalFunc}
        logoutFunc={logoutFunc}
        isHomepage={props.isHomepage}
        headerData={headerData}
      />
      {typeof window !== `undefined` && (
        <FTCommon loginState={loginFunc} modelType={showAuthModal} />
      )}
    </>
  );
};

Header.defaultProps = {
  siteId: 1,
  showHeaderList: true,
  forceDesktop: false
};

Header.propTypes = {
  siteId: PropTypes.number.isRequired,
  showHeaderList: PropTypes.bool,
  forceDesktop: PropTypes.bool,
  maxWidth: PropTypes.number,
  signInButtonModifierClassName: PropTypes.string,
  isHomepage: PropTypes.bool
};

export default Header;
